import styled from "styled-components";
import { SE_CLIENT_HEIGHT } from "../../../constants/data";
import {
  blackColor,
  lightSecondColor,
  orangeColor,
  whiteColor,
} from "../../../constants/colors";

const OffersBlock = styled.div`
  width: 100%;
  min-height: ${SE_CLIENT_HEIGHT};
  position: relative;
  display: flex;
  background: ${(props) => (props.theme !== "light" ? blackColor : "#E0DFF0")};
  opacity: 0;
  transition: 0.4s;
  &.visible {
    opacity: 1;
  }
  .blue {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
  }
  .purple {
    position: absolute;
    top: 300px;
    right: 0;
    display: block;
  }
  p,
  h1,
  h1,
  h3,
  h4,
  h5,
  span,
  a {
    color: ${(props) =>
      props.theme === "white" ? blackColor : lightSecondColor};
  }
`;

OffersBlock.Bg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: ${SE_CLIENT_HEIGHT}px;
  z-index: 1;
  .flowers {
    max-width: 575px;
    width: 100%;
    margin: 0 auto;
    object-fit: cover;
    position: relative;
  }
  .stars {
  }
  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    height: 70%;
    width: 100%;
    background: linear-gradient(180deg, rgba(5, 2, 55, 0) 0%, #050237 58.37%);
  }
  /*@media (min-width: 769px) {
    //opacity: 0;
    .flowers {
      max-width: none;
    }
  }*/
`;

OffersBlock.Stars = styled.div`
  position: relative;
  width: 100%;
  z-index: 2;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 30px;
  box-sizing: border-box;
  img {
    position: relative;
    top: 5px;
    width: 100%;
    max-width: 768px;
  }
  @media (min-width: 769px) {
    opacity: 0;
  }
`;

OffersBlock.Logo = styled.div`
  margin-top: 75px;
  position: relative;
  z-index: 2;
  img {
  }
`;

OffersBlock.Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
  margin-bottom: 43px;
  min-height: ${SE_CLIENT_HEIGHT - 100}px;
`;

OffersBlock.WhatYouGet = styled.div`
  text-align: left;
`

OffersBlock.WhatYouGet.Content = styled.div`
  margin-bottom: 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 30px 15px;
  
  .what-you-get-item {
    background-color: transparent;
    
    img {
      width: 160px;
      height: 160px;
    }
  }

  @media (max-width: 374px) {
    justify-content: center;
  }

  @media (min-width: 450px) {
    justify-content: center;
  }
`

OffersBlock.Comment = styled.div`
  border: 2px solid rgba(236, 235, 255, 0.1);
  border-radius: 12px;
  padding: 15px 15px 21px 15px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
`;

OffersBlock.Comment.Text = styled.div`
  margin-bottom: 18px;
`;

OffersBlock.Comment.Bottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

OffersBlock.Top = styled.div``;

OffersBlock.Plans = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 33px;
`;
OffersBlock.Plan = styled.div`
  display: flex;
  margin-bottom: 10px;
  border-radius: 12px;
  overflow: hidden;
  opacity: 0.6;
  justify-content: center;
  &.active {
    opacity: 1;
  }
`;
OffersBlock.Plan.Left = styled.div`
  flex-grow: 1;
  padding: 12px 15px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
OffersBlock.Plan.Dot = styled.div`
  width: 24px;
  height: 24px;
  border: 2px solid #ffffff;
  box-sizing: border-box;
  border-radius: 50%;
  transition: 0.2s;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
  &.active {
    border: 2px solid ${orangeColor};
  }
`;

OffersBlock.Plan.Dot.Item = styled.div`
  opacity: 0;
  width: 14px;
  height: 14px;
  box-sizing: border-box;
  border-radius: 50%;
  transition: 0.2s;
  background: ${orangeColor};
  &.active {
    opacity: 1;
  }
`;

OffersBlock.Plan.Text = styled.div``;
OffersBlock.Plan.Right = styled.div`
  width: 88px;
  padding: 12px 15px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

OffersBlock.Bottom = styled.div`
  .decor {
    position: relative;
    color: #000;
    text-decoration: none;
    width: 112px;
  }
  .decor:before {
    content: "";
    border-bottom: 2px solid ${whiteColor};
    position: absolute;
    width: 100%;
    height: 50%;
    //transform: rotate(-12deg);
  }
`;

OffersBlock.ButtonBlock = styled.div`
  padding-top: 25px;
  padding-bottom: 25px;
  width: 100%;
  box-shadow: 0px -0.5px 0px;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 3;
  border-top: 1px solid #e5e5e5;
`;

export { OffersBlock };
